import { render, staticRenderFns } from "./NotificationCartsExpiringSoon.vue?vue&type=template&id=6c1eec88&"
import script from "./NotificationCartsExpiringSoon.vue?vue&type=script&lang=js&"
export * from "./NotificationCartsExpiringSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports